export default [
  {
    path: "/rapormusteriyetki",
    name: "rapormusteriyetki",
    component: () => import("./index.vue"),
    meta: {
      public: false,
      title: "rapormusteriyetki.Baslik",
      yetki: { k: [2001202] },
    },
  },
]
